import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Chip,
  Box,
  TableSortLabel,
  Typography,
} from '@mui/material';
import { EditOutlined, DeleteOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useSortTable from '../../../hooks/useSortTable';

const RetentionLineTable = ({ lines, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const { sorted, sortBy, sortDir, handleSort } = useSortTable(lines);

  const SortCell = ({ label, field, align, sx: extraSx }) => (
    <TableCell align={align} onClick={() => handleSort(field)} sx={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', ...extraSx }}>
      <TableSortLabel active={sortBy === field} direction={sortBy === field ? sortDir : 'asc'}>
        {label}
      </TableSortLabel>
    </TableCell>
  );

  const getDispositionChips = (line) => {
    const dispositions = [];
    if (line.dispositionCt) dispositions.push({ label: 'CT', tooltip: 'Conservacion Total', color: 'success' });
    if (line.dispositionE) dispositions.push({ label: 'E', tooltip: 'Eliminacion', color: 'error' });
    if (line.dispositionM) dispositions.push({ label: 'M', tooltip: 'Microfilmacion', color: 'info' });
    if (line.dispositionD) dispositions.push({ label: 'D', tooltip: 'Digitalizacion', color: 'primary' });
    if (line.dispositionS) dispositions.push({ label: 'S', tooltip: 'Seleccion', color: 'warning' });
    return dispositions;
  };

  return (
    <Paper sx={{ overflow: 'hidden' }}>
      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <SortCell label="Serie" field="series" />
              <SortCell label="Subserie" field="subseries" />
              <SortCell label="Codigo" field="code" />
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Ret. Local</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Ret. Central</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Disposicion</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Expedientes</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>Documentos</TableCell>
              <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                  No hay lineas de retencion. Haz clic en "Nueva Linea" para agregar una.
                </TableCell>
              </TableRow>
            ) : (
              sorted.map((line) => (
                <TableRow
                  key={line.id}
                  hover
                  onClick={() => navigate(`/retentions/lines/${line.id}`)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>
                    <Typography variant="body2" sx={{ fontFamily: '"Barlow Condensed", system-ui, sans-serif', fontWeight: 600 }}>
                      {line.series}
                    </Typography>
                  </TableCell>
                  <TableCell><Typography variant="body2">{line.subseries}</Typography></TableCell>
                  <TableCell><Typography variant="body2">{line.code}</Typography></TableCell>
                  <TableCell><Typography variant="body2">{line.localRetention} anos</Typography></TableCell>
                  <TableCell><Typography variant="body2">{line.centralRetention} anos</Typography></TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                      {getDispositionChips(line).map((disp, index) => (
                        <Tooltip key={index} title={disp.tooltip}>
                          <Chip label={disp.label} size="small" color={disp.color} sx={{ minWidth: 32 }} />
                        </Tooltip>
                      ))}
                      {getDispositionChips(line).length === 0 && (
                        <Typography variant="body2">&mdash;</Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell><Typography variant="body2">{line._count?.proceedings ?? 0}</Typography></TableCell>
                  <TableCell><Typography variant="body2">{line._count?.documents ?? 0}</Typography></TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }} onClick={(e) => e.stopPropagation()}>
                    <Box sx={{ display: 'inline-flex', gap: 0.25 }}>
                      <Tooltip title="Editar">
                        <IconButton size="small" onClick={() => onEdit(line)} sx={{ color: '#5d5d60', width: 36, height: 36 }}>
                          <EditOutlined sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Eliminar">
                        <IconButton size="small" onClick={() => onDelete(line.id)} sx={{ color: '#5d5d60', width: 36, height: 36 }}>
                          <DeleteOutlined sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default RetentionLineTable;
